import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3996592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "megaSpinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fplogo = _resolveComponent("fplogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_fplogo),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}